// A page screenshot inside a minimal browser frame. `motion` picks how the
// tall screenshot moves: "auto" loops, "hover" scrolls while the parent
// `.group` is hovered or focused, "none" stays at the top.
export default function BrowserShot({
  src,
  alt,
  url,
  motion = "none",
  priority = false,
  className = "",
  imageClassName = "aspect-[16/10]",
  width = 960,
  height = 3600,
}) {
  const motionClass = { auto: "shot-autoscroll", hover: "shot-hoverscroll", none: "" }[motion];
  return (
    <div className={`overflow-hidden rounded-xl border border-border bg-background ${className}`}>
      <div aria-hidden="true" className="flex h-7 items-center gap-1.5 border-b border-border bg-muted px-3">
        <span className="h-2 w-2 rounded-full bg-foreground/15" />
        <span className="h-2 w-2 rounded-full bg-foreground/15" />
        <span className="h-2 w-2 rounded-full bg-foreground/15" />
        {url && (
          <span className="ml-2 truncate text-[11px] text-muted-foreground">
            {url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "")}
          </span>
        )}
      </div>
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        className={`block w-full object-cover object-top ${imageClassName} ${motionClass}`}
      />
    </div>
  );
}
